module.exports = __webpack_public_path__ + "img/eb09c86.jpg";